import React, { useEffect } from 'react';
import moment from 'moment';
import { NavLink, useHistory } from 'react-router-dom';

import RecipesList from '../Visits/resipesList';
import RecipeSkeleton from './RecipeSkeleton';
import EmptyData from '../../../components/global/emptyData';
import BuyRecipes from '../../common/buyRecipes';
import { useVisitsSkeleton } from './api';

const PersonalRecipes = ({ patient }) => {
  const history = useHistory();
  const patientId = patient.data?.id;

  const { skeleton, detailsMap, loadingProviders, loading, load } = useVisitsSkeleton({ patientId });

  useEffect(() => {
    if (patientId && skeleton === null && !loading) {
      load(1);
    }
  }, [patientId]); // eslint-disable-line react-hooks/exhaustive-deps

  // All details loaded and none have drugs → empty state
  const allLoaded = skeleton !== null && !loadingProviders.size;
  if (allLoaded && skeleton.length > 0) {
    const hasAnyDrugs = skeleton.some((item) => detailsMap[item.id]?.drugs?.length);
    if (!hasAnyDrugs) return <EmptyData />;
  }
  if (allLoaded && skeleton.length === 0) return <EmptyData />;

  return (
    <div className="personal-recipes-wrapper">
      <div className="personal-recipes">
        <div className="streaming-records-title">
          Призначені ліки
          <div className="streaming-records-title-records-wrapper">
            <div className="streaming-records-title-records-item" onClick={() => history.push('/office/visits')}>
              <i className="fas fa-list-alt" />
              Всі візити
            </div>
          </div>
        </div>

        <ul className="personal-recipes-data-list">
          {skeleton === null
            ? [0, 1, 2].map((i) => <RecipeSkeleton key={i} />)
            : skeleton.map((item) => {
                const full = detailsMap[item.id];
                if (!full) {
                  return <RecipeSkeleton key={item.id} isLoading={loadingProviders.has(item.provider_id)} />;
                }
                if (!full.drugs?.length) return null;
                const { id, date, drugs, buy_url } = full;
                return (
                  <li className="personal-recipes-data-list__item" key={id}>
                    <div className="personal-recipes-data-list__item-information">
                      <div className="personal-recipes-data-list__item-date">
                        <div className="personal-recipes-data-list__item-date-title">Дата візиту</div>
                        <div className="personal-recipes-data-list__item-date-description">
                          <i className="fas fa-calendar-alt" /> {moment(date).format('DD.MM.YYYY')}
                        </div>
                      </div>
                      <NavLink to={`/office/visits/${id}`} className="personal-recipes-data-list__item-link">
                        До візиту
                      </NavLink>
                    </div>
                    <RecipesList drugs={drugs} />
                    <BuyRecipes buUrl={buy_url} />
                  </li>
                );
              })}
        </ul>
      </div>
    </div>
  );
};

export default PersonalRecipes;
